import { prefixObjectValues as pre } from '../utils';

const prefix = 'attestations-table';

const table = pre(
  {
    row: 'row-',
    dateSubmitted: 'date-sort',
    type: 'type-sort',
    status: 'status-sort',
    actions: 'actions-sort',
    deleteBtn: 'delete-btn',
    addBtn: 'add-btn',
    editBtn: 'edit-btn',
    downloadBtn: 'download-btn',
    check: 'green-check',
    warning: 'red-warning',
    emptyState: 'empty-state',
  },
  prefix
);

export default {
  ...table,
};
